import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { API_BASE_URL } from "../../../../config";
import { getAdminAuthToken } from "../../../../auth/auth";

export default function InviteAdmins({ onInviteSuccess }) {
  const [handleText, setHandleText] = useState("Send Invite");
  const [handleFormValue, setHandleFormValue] = useState({
    full_name: "",
    email: "",
  });

  const handleForm = (name, value) => {
    setHandleFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = getAdminAuthToken();

    try {
      setHandleText("Sending Invite...");
      const response = await fetch(`${API_BASE_URL}/admin/admins`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: handleFormValue.full_name,
          email: handleFormValue.email,
        }),
      });

      const result = await response.json();

      if (!result.success) {
        toast.error(result.message);
        setHandleText("Send Invite");
        return;
      }

      toast.success("Admin invited successfully!");
      setHandleText("Send Invite");

      setHandleFormValue({
        full_name: "",
        email: "",
      });

      if (onInviteSuccess) {
        onInviteSuccess();
      }
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  return (
    <>
      <div className="invite-admin-wrapper">
        <h3>Invite Admin</h3>
        <div className="invite-wrapper-form">
          <p>Send invitation link to the admin</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="full_name"
                placeholder="Full Name"
                onChange={(e) => handleForm(e.target.name, e.target.value)}
                required
                value={handleFormValue.full_name}
              />
            </div>
            <div className="form-group">
              <label>Admin Email</label>
              <input
                type="email"
                name="email"
                placeholder="Email"
                required
                value={handleFormValue.email}
                onChange={(e) => handleForm(e.target.name, e.target.value)}
              />
            </div>
            <button type="submit" className="btn-all-white">
              {handleText}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
